import React from 'react';
import useFormFlow from "modules/forms/hooks/useFormFlow";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";
import BlockWrapper from "modules/forms/embedded/blocks/BlockWrapper";
import { makeId } from "modules/forms/embedded/components/helpers";

export type SubmitButtonBlockType = Omit<FormBlockType, "data"> & {
    data: {
        label: string;
    },
}

export default function SubmitButtonBlock(block: SubmitButtonBlockType) {
    const { data: { label } } = block;
    const { isSubmitting } = useFormFlow();

    return (
        <BlockWrapper name={block.name} hidden={false}>
            <button id={makeId("submit-button")} disabled={isSubmitting} type={"submit"}>
                {label}
            </button>
        </BlockWrapper>
    );
}